<kds-dialog class="save-changes-modal">
  <div kds-dialog-header>{{ 'ip-access-page.save-changes-modal.header' | translate }}</div>
  <div main class="save-changes-modal__main">
    <p class="save-changes-modal__description">
      <span>{{ 'ip-access-page.save-changes-modal.text-part-1' | translate }}</span>
      <span class="save-changes-modal__description--bold">
        {{ 'ip-access-page.save-changes-modal.text-part-2' | translate }}
      </span>
      <span>{{ 'ip-access-page.save-changes-modal.text-part-3' | translate }}</span>
      <span class="save-changes-modal__description--bold">
        {{ 'ip-access-page.save-changes-modal.text-part-4' | translate }}
      </span>
      <span>{{ 'ip-access-page.save-changes-modal.text-part-5' | translate }}</span>
    </p>
  </div>
  <div kds-dialog-actions>
    <kds-regular-button
      [buttonText]="'buttons.cancel' | translate"
      [colorScheme]="'secondary'"
      [testId]="testIds.cancelButton"
      (buttonClick)="onCancelButton()"
    />
    <kds-regular-button [buttonText]="'buttons.ok' | translate" [testId]="testIds.submitButton" (buttonClick)="onOkButton()" />
  </div>
</kds-dialog>
